export default {"src":"/_next/static/media/grievance.47794928.svg","height":440,"width":440,"blurWidth":0,"blurHeight":0};